export default __webpack_public_path__ + "static/media/FrontCover.0c1f3ebb.txt";